import React from "react";
import { Box, Container, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FolderIcon from "@mui/icons-material/Folder";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styles from "./SolutionsPage.module.css";
import default_theme from "assets/themes/themes";

const SolutionsPage = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  const cards = [
    {
      icon: <FolderIcon />,
      title: 'Rural Development',
      description: 'Explore rural development solutions and best practices.',
      path: "/solutions/rural-development",
      color: default_theme.palette.other.accentBlue
    }
  ];

  return (
    <Box sx={{
      flex: 1,
      minHeight: 0,
      height: '100%',
      display: 'flex',
    }}
    className={styles.solutionContainer}>
      <Container maxWidth="lg" className={styles.mainContainer}>
        <Box className={styles.contentWrapper}>
          <Box className={styles.headerSection}>
            <Typography variant="h1" className={styles.pageTitle}>
              Solutions
            </Typography>
            <Typography variant="h2" className={styles.pageSubtitle}>
              Discover categorized solutions for rural development.
            </Typography>
          </Box>
          <Box className={styles.cardsSection}>
            {cards.map((card, index) => (
              <Box 
                key={index}
                className={styles.cardItem}
                onClick={() => handleCardClick(card.path)}
                sx={{
                  '--card-color': card.color,
                  '--card-delay': `${index * 0.1}s`,
                  cursor: 'pointer'
                }}
              >
                <Box className={styles.cardContent}>
                  <Box className={styles.cardMain}>
                    <Box className={styles.iconWrapper}>
                      <Box className={styles.iconBackground} />
                      <Box className={styles.iconContainer}>
                        {React.cloneElement(card.icon, { className: styles.cardIcon })}
                      </Box>
                    </Box>
                    <Box className={styles.textContent}>
                      <Typography className={styles.cardTitle}>
                        {card.title}
                      </Typography>
                      <Typography className={styles.cardDescription}>
                        {card.description}
                      </Typography>
                    </Box>
                  </Box>
                  <IconButton className={styles.arrowButton}>
                    <ArrowForwardIcon />
                  </IconButton>
                </Box>
                <Box className={styles.cardBackground} />
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SolutionsPage; 